import React, { Component, createRef } from 'react'
import { Map, TileLayer } from 'react-leaflet'
import CustomMarker from '../CustomMarker'
import { observer } from 'mobx-react';
import { locations } from '../../firestorter';
import { CONSTANTS } from '../../utils';
import LocateControl from '../Locate'
import axios from 'axios';

const MMap = observer(class MMap extends Component {
    constructor() {
        super()
        this.mapRef = React.createRef();
        this.state = {

        }
    }
    updateDimensions() {
        const headerElem = document.getElementById('header')

        const height = window.innerHeight - ((headerElem && headerElem.offsetHeight) || 0)
        const width = window.innerWidth
        this.setState({ height: height, width: width })
    }

    componentWillMount() {
        this.updateDimensions()
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions.bind(this))
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this))
    }

    onContextMenu(event) {
        console.log("##MMap Component", "onContextMenu")
        // open the "add report" panel with this latlng
        const latlng = event.latlng
        if (window.navigator.vibrate) {
            window.navigator.vibrate(100)
        }

        // open the "add report" panel with this latlng
        this.props.onMapClicked(latlng)
    }

    render() {
        const self = this
        const currentTimestamp = new Date().getTime() / 1000

        const _locations = locations.docs.map((doc, i) => {
            const location = doc.data
            if (location.latlng && !location.deleted) {
                const position = {
                    lat: location.latlng.latitude,
                    lng: location.latlng.longitude,
                }

                let showUserPic = false

                // Checking for location.lastReport.createdOn for known reason for now... :|
                if (location.lastReport && location.lastReport.score === CONSTANTS.REPORT_SCORE.CLEAN && location.lastReport.createdOn) {
                    const beforeSec = currentTimestamp - location.lastReport.createdOn.seconds
                    showUserPic = beforeSec < 6 * CONSTANTS.DURATION_IN_SEC.DAY
                }

                return (
                    <CustomMarker
                        showUserPic={showUserPic}
                        position={position}
                        location={location}
                        key={i}
                        onLocationClicked={function () { this.props.onLocationClicked(location, doc.id) }.bind(self)}>
                    </CustomMarker>)
            }

            return null
        })
        /**
         * https://www.domoritz.de/leaflet-locatecontrol/
         */
        const locateOptions = {
            flyTo: 'true',
            position: 'topright',
            keepCurrentZoomLevel: true,
            locateOptions: {
                enableHighAccuracy: false,
                maxZoom: 10
            },
            showPopup: false,
            onLocationError: async function (err, control) {
                //if (!self.props.store.location_obtained) {
                //const freeGeoIP = await axios.get('https://freegeoip.app/json/');
                const freeGeoIP = await axios.get('https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572');
                //https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572
                
                self.props.store.map_center.lat = freeGeoIP.data.latitude
                self.props.store.map_center.lng = freeGeoIP.data.longitude

                //Fly to
                const map = self.mapRef.current
                if (map != null) {

                    map.leafletElement.flyTo([self.props.store.map_center.lat, self.props.store.map_center.lng])
                }
            }
        }

        return (
            <div>
                <Map
                    ref={this.mapRef}
                    style={{ width: this.state.width, height: this.state.height }}
                    center={[this.props.center.lat, this.props.center.lng]}
                    zoom={this.props.zoom}
                    oncontextmenu={this.onContextMenu.bind(this)}>
                    <TileLayer
                        attribution='&amp;copy <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    <LocateControl options={locateOptions} startDirectly />

                    {_locations}
                </Map>
            </div>
        )
    }
})


export default MMap